/*
|--------------------------------------------------------------------------
| Views: htmlWidget
|--------------------------------------------------------------------------
*/

/**
 * htmlWidget View
 * @namespace
 */
__gh__webApp.views.htmlWidget = {

	"callbacks": function(bucket){
		var utilities		= __gh__webApp.utilities;
		utilities.fetch.html.loadAllHTML();
	}
};
